/** Tipos de garantía al agendar (código VW / interno). */
export const WARRANTY_TYPES = [
  { code: '110', label: 'Normal 110' },
  { code: '710', label: 'Campaña 710' },
  { code: 'IAG', label: 'IAG desp. 2 años' },
  { code: '210', label: 'Garantía de favor 210' },
  { code: '910', label: 'Garantía en stock 910' },
  { code: '790', label: 'Campaña en stock 790' },
  { code: '121', label: 'Garantía repuesto 121' },
];

export const DEFAULT_WARRANTY_TYPE_CODE = '110';

/** Estados del flujo de garantía.
 * PENDIENTE → EN CURSO → REP. AGENDADA → REP. FINALIZADA → FINALIZADA
 * (NO GARANTÍA cierra el caso sin reparación)
 */
export const WARRANTY_STATUSES = [
  'PENDIENTE',
  'EN CURSO',
  'REP. AGENDADA',
  'REP. FINALIZADA',
  'FINALIZADA',
  'NO GARANTÍA',
  'Cancelado',
];

export const DEFAULT_WARRANTY_STATUS = 'PENDIENTE';

export function getWarrantyTypeLabel(code) {
  const found = WARRANTY_TYPES.find((t) => t.code === String(code));
  return found?.label || (code ? String(code) : '');
}

/** Valor para input type="date" (YYYY-MM-DD). */
export function formatDateInputValue(raw) {
  if (raw == null || raw === '') return '';
  if (raw instanceof Date) {
    return `${raw.getFullYear()}-${String(raw.getMonth() + 1).padStart(2, '0')}-${String(raw.getDate()).padStart(2, '0')}`;
  }
  const text = String(raw);
  const match = text.match(/^(\d{4}-\d{2}-\d{2})/);
  if (match) return match[1];
  return text.slice(0, 10);
}

/** Vencimiento guardado en la garantía o fin de garantía del vehículo. */
export function resolveWarrantyExpiration(warranty, service) {
  const fromWarranty = formatDateInputValue(warranty?.warrantyExpiration);
  if (fromWarranty) return fromWarranty;
  return formatDateInputValue(service?.vehicle?.warrantyEndDate);
}

export function isWarrantyServiceType(serviceTypeOrId, serviceTypes = []) {
  if (serviceTypeOrId == null || serviceTypeOrId === '') return false;

  const type =
    serviceTypeOrId && typeof serviceTypeOrId === 'object'
      ? serviceTypeOrId
      : serviceTypes.find((t) => Number(t.id) === Number(serviceTypeOrId));

  if (type) {
    const name = String(type?.name || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
    if (name.includes('garant')) return true;
    return Number(type.id) === 2;
  }

  // Sin catálogo cargado: id 2 es "Garantia" en el seed del sistema.
  return Number(serviceTypeOrId) === 2;
}

export function isRepairServiceType(serviceTypeOrId, serviceTypes = []) {
  if (serviceTypeOrId == null || serviceTypeOrId === '') return false;

  const type =
    serviceTypeOrId && typeof serviceTypeOrId === 'object'
      ? serviceTypeOrId
      : serviceTypes.find((t) => Number(t.id) === Number(serviceTypeOrId));

  if (type) {
    const name = String(type?.name || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
    if (name.includes('reparacion')) return true;
    const id = Number(type.id);
    return id === 3 || id === 7;
  }

  // Sin catálogo: id 3 = Reparación, id 7 = Reparación repetida
  const id = Number(serviceTypeOrId);
  return id === 3 || id === 7;
}

function normalizeAgendaText(value) {
  return String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

/** Cita de ingreso / diagnóstico de garantía (no confundir con reparación). */
export function isWarrantyDiagnosisAgenda(
  agenda,
  diagnosisVehicleServiceId = null,
) {
  if (!agenda) return false;
  const diagnosisId = Number(diagnosisVehicleServiceId);
  const linkedVsId = Number(agenda.vehicleServiceId);
  if (diagnosisId > 0 && linkedVsId === diagnosisId) return true;
  if (
    isWarrantyServiceType(agenda.serviceTypeId) ||
    isWarrantyServiceType(agenda.serviceType)
  ) {
    return true;
  }
  const desc = normalizeAgendaText(agenda.description);
  return desc.includes('garant') && !desc.includes('reparacion');
}

/** Cita de reparación vinculada a una garantía (reutilizable al reprogramar). */
export function isWarrantyRepairAgendaItem(agenda, serviceTypes = []) {
  if (!agenda || isWarrantyDiagnosisAgenda(agenda)) return false;
  if (
    isRepairServiceType(agenda.serviceTypeId, serviceTypes) ||
    isRepairServiceType(agenda.serviceType, serviceTypes)
  ) {
    return true;
  }
  const desc = normalizeAgendaText(agenda.description);
  return desc.includes('reparacion') && desc.includes('garant');
}

/** Texto de garantía en descripción / nombre (p. ej. "Reparación de garantía"). */
export function hasWarrantyText(source = {}) {
  const agendaText = Array.isArray(source?.agenda)
    ? source.agenda.map((item) => item?.description)
    : [source?.agenda?.description];
  const text = [
    source?.description,
    source?.serviceName,
    source?.service?.name,
    ...agendaText,
  ]
    .join(' ')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
  return text.includes('garant');
}

/** Garantía / reparación: solo resumen técnico (sin tareas ni repuestos). */
export function isSimplifiedWorkshopView(
  serviceTypeOrId,
  serviceTypes = [],
  extras = {},
) {
  if (extras?.warrantyType) return true;
  if (hasWarrantyText(extras)) return true;
  return (
    isWarrantyServiceType(serviceTypeOrId, serviceTypes) ||
    isRepairServiceType(serviceTypeOrId, serviceTypes)
  );
}
